import { render, staticRenderFns } from "./classifySetting.vue?vue&type=template&id=6b9596fb&scoped=true&"
import script from "./classifySetting.vue?vue&type=script&lang=js&"
export * from "./classifySetting.vue?vue&type=script&lang=js&"
import style0 from "./classifySetting.vue?vue&type=style&index=0&id=6b9596fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9596fb",
  null
  
)

export default component.exports